import {
  Form,
  Switch,
  InputNumber,
  Input,
  Checkbox,
  TimePicker,
  DatePicker,
  Col,
  Row,
} from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

export const FORM_ART = {
  DEFAULT: 0, // Texteingabe
  NUMBER: 1, // Zahleneingabe
  CHECKBOX: 2, // Checkbox
  SWITCH: 3, // Switch
  TIME: 4, // Time
  DATE: 5, // DateTime
  EMAIL: 6, // EMail
  BETRAG:7, // Betrag mit 2NK
};

export const getDrawerdatenRowEdits = (EditProps) => {
  let loop = 0;
  //console.log(`getDrawerdatenRowEdits=${EditProps.length}`);

  return EditProps.map((group, groupIndex) => {
    //console.log(`formRowItem=${groupIndex}`);
    loop++;
    let rowInfo = null;
    const groupElements = group.map((p, elementIndex) => {
      loop++;
      if (p.row && p.row !== "") rowInfo = p.row;
      if (rowInfo !== "")
        return (
          <Col key={elementIndex}>
            <FormItemElement
              itemkey={`formItem_${groupIndex}_${elementIndex}x${loop}`}
              props={p}
            />
          </Col>
        );
      else
        return (
          <FormItemElement
            itemkey={`formItem_${groupIndex}_${elementIndex}x${loop}`}
            props={p}
          />
        );
    });
    if (rowInfo) {
      // console.log(`formRowItem_${groupIndex}x${loop}`);
      return (
        <>
          <Row {...rowInfo} key={`formRowItem_${groupIndex}x${loop}`}>
            {groupElements}
          </Row>
        </>
      );
    } else return groupElements;
  });
};

export const getDrawerdatenEdits = (EditProps) => {
  return EditProps.map((p, i) => {
    return (
      <>
        <FormItemElement itemkey={i} props={p} />
      </>
    );
  });
};

export const FormItemElement = ({ props, layout, itemkey }) => {
  let {
    art,
    label,
    feld,
    place,
    required,
    minuteStep = 15,
    needConfirm = true,
    userComp,
    handleChange,
    disabled,
    itemStyle,
    inputStyle,
  } = props;
  let key = "Edit" + (itemkey || feld);
  layout = layout || "vertical";
  const getRoules = (rules = []) => {
    if (required) {
      rules.push({
        required: true,
        message: required || "Bitte füllen Sie dieses Feld aus!",
      });
    }
    return rules;
  };

  switch (art) {
    case FORM_ART.NUMBER: {
      return (
        <>
          <Form.Item
            key={key}
            layout={layout}
            label={label}
            name={feld}
            style={{ marginBottom: 3 }}
            rules={getRoules()}
          >
            <InputNumber placeholder={place}  onChange={handleChange} />
          </Form.Item>
        </>
      );
    }
    case FORM_ART.BETRAG: {
      return (
        <>
          <Form.Item
            key={key}
            layout={layout}
            label={label}
            name={feld}
            style={{ marginBottom: 3 }}
            rules={getRoules()}
          >
            <InputNumber 
             min={0}
             step={0.01}
             precision={2}
            placeholder={place}  
            onChange={handleChange} 
            style={{ width: '100%',maxWidth:100, textAlign: 'right' }}
            />
          </Form.Item>
        </>
      );
    }
    case FORM_ART.CHECKBOX: {
      return (
        <>
          <Form.Item
            key={key}
            layout={layout}
            //label={label}
            name={feld}
            style={{ marginBottom: 3 }}
            valuePropName="checked"
          >
            <Checkbox>{props.label}</Checkbox>
          </Form.Item>
        </>
      );
    }
    case FORM_ART.SWITCH: {
      return (
        <>
          <Form.Item
            key={key}
            layout={layout}
            label={label}
            style={
              itemStyle
                ? itemStyle
                : {
                    display: "inline-block",
                    marginLeft: 5,
                    marginBottom: 3,
                  }
            }
            name={feld}
          >
            <Switch
              onChange={handleChange}
              //defaultChecked={infoUser[statusFieldName]}
              //defaultChecked={defaultChecked}
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              name={feld}
            />
          </Form.Item>
        </>
      );
    }
    case FORM_ART.TIME: {
      return (
        <>
          <Form.Item
            key={key}
            layout={layout}
            label={label}
            name={feld}
            style={itemStyle ? itemStyle : { marginBottom: 3 }}
            rules={[
              {
                type: "object",
                required: true,
                message: "Bitte geben Sie eine Uhrzeit ein!",
              },
            ]}
          >
            <TimePicker
              format="HH:mm"
              changeOnScroll
              needConfirm={needConfirm}
              minuteStep={minuteStep}
              showNow={false}
              onChange={handleChange}
            />
          </Form.Item>
        </>
      );
    }
    case FORM_ART.DATE: {
      return (
        <>
          <Form.Item
            key={key}
            style={itemStyle ? itemStyle : { marginBottom: 3 }}
            layout={layout}
            label={label}
            name={feld}
            rules={getRoules()}
          >
            <DatePicker showTime={false} format="DD.MM.YYYY" onChange={handleChange} />
          </Form.Item>
        </>
      );
    }

    case FORM_ART.EMAIL: {
      return (
        <>
          <Form.Item
            name={feld}
            label={label}
            key={key}
            layout={layout}
            style={itemStyle ? itemStyle : { marginBottom: 3 }}
            rules={getRoules([
              {
                type: "email",
                message: "Ungültige E-Mail-Adresse",
              },
            ])}
          >
            <Input type="email" placeholder={place} disabled={disabled}  onChange={handleChange} />
          </Form.Item>
        </>
      );
    }
    default: {
      if (userComp) return userComp;
      //FORM_ART.DEFAULT
      return (
        <>
          <Form.Item
            key={key}
            layout={layout}
            label={label}
            name={feld}
            style={itemStyle ? itemStyle : { marginBottom: 3 }}
            rules={getRoules()}
            
            //labelCol={{ span: 24 }}  // Ausblenden der Beschriftungsspalte
            //wrapperCol={{ span: 24 }}  // Nutzung der gesamten Breite für das Eingabefeld
          >
            <Input placeholder={place} style={inputStyle && inputStyle} disabled={disabled} onChange={handleChange}/>
          </Form.Item>
        </>
      );
    }
  }
};
